<template>
  <div>
    <div v-if="isCancelling">
      <p class="font-semibold">
        {{ $t('Do you really want to cancel your subscription for this project?') }}
      </p>
      <p class="mt-1">
        {{ $t('Your project will remain active until the end of the current billing period. No further charges will be made.') }}
      </p>
      <a href="#" class="btn-danger inline-flex mt-3" @click.prevent="handleCancelSubscription()"
        >{{ $t('I really want to cancel my subscription') }}</a
      >
    </div>
    <a v-else class="text-red-600 hover:text-red-700 hover:underline" href="#" @click.prevent="isCancelling = true"
      >{{ $t('Cancel subscription') }}</a
    >
    <div
      v-if="error"
      class="error_show mt-2"
      >{{this.error}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cancelUrl: String,
    isCancelling: false,
    error: '',
  },

  data: function () {
    return {};
  },
  methods: {
    handleCancelSubscription: function () {
      Rails.ajax({
        url: this.cancelUrl,
        type: "DELETE",
        beforeSend: function () {
          return true;
        },
        success: (data) => {
          location.reload();
        },
        error: (data, status) => {
          this.error = data.message
        },
      });
    },
  },
};
</script>
